import { Box, Drawer as MuiDrawer } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Drawer = styled(MuiDrawer)`
  > .MuiPaper-root {
    width: 30%;
    background: ${theme.colors.surfaceContainerBackground};
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100vh;

    .ssm-drawer-actions-wrapper {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.xSmall}px;
      width: 100%;
      padding: ${theme.spacing.large}px ${theme.spacing.xLarge}px;
      flex-shrink: 0;

      @media (max-width: 1280px) {
        padding: ${theme.spacing.large}px ${theme.spacing.small}px;
      }

      .add-product-button {
        width: 100%;
      }
    }
  }
`

export const Wrapper = styled(Box)`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .header {
    flex-shrink: 0;
    padding: ${theme.spacing.xLarge}px ${theme.spacing.xLarge}px ${theme.spacing.medium}px;
    display: flex;
    align-items: center;

    .missing-vendor-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #c3c3c3;
      border-radius: ${theme.attributes.borderRadius.circle};
      color: ${theme.baseColors.greyscale[0]};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.header};
      font-weight: ${theme.typography.fontWeight.bold};
      min-width: 44px !important;
      min-height: 44px !important;
      height: 44px !important;
      width: 44px !important;
    }

    @media (max-width: 1280px) {
      padding: ${theme.spacing.xLarge}px ${theme.spacing.small}px ${theme.spacing.medium}px;
    }

    .back-button {
      margin-right: ${theme.spacing.xSmall}px;

      &:hover {
        background: ${theme.colors.legacyAlpha8};
      }
    }

    .add-product-logo {
      width: 44px;
      height: 44px;
      border-radius: ${theme.attributes.borderRadius.secondary};
      background: lightgray 50% / cover no-repeat;
      margin-right: ${theme.spacing.small}px;

      img {
        width: 44px;
        height: 44px;
        min-width: 44px;
        min-height: 44px;
        border-radius: ${theme.attributes.borderRadius.secondary};
        object-fit: cover;
        object-position: center;
      }
    }

    .MuiTypography-root {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xxxxLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 42px;
      flex-grow: 1;
      text-transform: capitalize;
    }

    .close-icon {
      width: 40px;
      height: 40px;
      color: ${theme.colors.menuItemText};

      &:hover {
        background: ${theme.colors.legacyAlpha8};
      }
    }
  }

  .sub-header {
    padding-left: ${theme.spacing.xLarge}px;
    padding-right: ${theme.spacing.xLarge}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;

    @media (max-width: 1280px) {
      padding-left: ${theme.spacing.small}px;
      padding-right: ${theme.spacing.small}px;
    }

    .sub-header-left,
    .sub-header-right {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.half}px;

      .sub-header-title {
        color: ${theme.colors.cardDateText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 22px;
      }

      .sub-header-text {
        color: ${theme.colors.menuItemText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 22px;

        span {
          color: ${theme.colors.calendarDay};
        }
      }
    }
  }
`

export const ProductsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md}px;
  padding: ${theme.spacing.small}px ${theme.spacing.xLarge}px 0;
  flex: 1;
  overflow-y: auto;

  margin-right: 4px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.borderMedium};
    border-radius: 100px;
  }

  @media (max-width: 1280px) {
    padding: ${theme.spacing.small}px ${theme.spacing.small}px 0;
  }
`

export const ProductSkeleton = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  border: 1px solid ${theme.colors.strokePrimary};
  border-radius: ${theme.attributes.borderRadius.secondary};

  .card-skeleton-inner {
    width: 100%;
    height: 100%;
    min-width: 44px;
    min-height: 44px;

    &:after {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 15.32%,
        rgba(255, 255, 255, 0.35) 49.89%,
        rgba(255, 255, 255, 0) 83.78%
      );
    }
  }
`

export const searchProductsPaperSx = {
  marginBottom: `${theme.spacing.xSmall}px`,
  background: theme.colors.borderMedium,
  borderRadius: theme.attributes.borderRadius.tertiary,
  boxShadow: '0 4px 8px 0 rgba(30, 26, 29, 0.20)',
  "html[data-theme='light'] &": {
    background: theme.colors.surfaceContainerBackground,
    boxShadow: '0 4px 8px 0 rgba(162, 145, 158, 0.20)'
  }
}
